module.exports = __webpack_public_path__ + "img/three@3x.20860357.png";